import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap/lib';
//import '../style/components/main.css'
import '../style/components/Maintenance.scss'
import { Link } from 'react-router-dom';

class Maintenance extends Component {
    componentWillReceiveProps(nextProps) {

    }

    componentWillMount() {
    }

    render() {

        return (
            <div className="is-loading" style={{ height:'100vh' }}>

                <div className="fullscreen-bg">
                    <video loop muted autoPlay poster="../assets/overlay.png" className="fullscreen-bg__video">
                        <source src="../assets/coding.webm" type="video/webm" />
                        <source src="../assets/coding.mp4" type="video/mp4" />
                    </video>
                </div>

                <div id="wrapper">

                    <section id="main" style={{ fontSize:'11pt' }}>
                        <header>
                            <span className="avatar">
                                <img src="../assets/avatar.jpg" height="122" width="122" alt="" />
                            </span>
                            <h1>NATUS.IO</h1>
                            <p>Ignacio Agustín del Barrio</p>
                        </header>

                        <main>
                            <ul className="icons">
                                <li>
                                    <a href="https://www.linkedin.com/in/ignatus" className="fa-linkedin">LinkedIn</a>
                                </li>
                                <li>
                                    <a href="https://github.com/coingod" className="fa-github">GitHub</a>
                                </li>
                                <li>
                                    <a href="https://ar.pinterest.com/ignatuus/" className="fa-pinterest">Pinterest</a>
                                </li>
                                <li>
                                    <a href="mailto:ignacioa.del.barrio@gmail.com?Subject=Hello%20World!" target="_top" className="fa-at">Email</a>
                                </li>
                            </ul>
                        </main>

                        <footer>
                            <h2><a href="/downloads/CV_Ignacio_del_Barrio_eng.pdf">Resume</a></h2>
                            <h6 style={{ float:"left" }}><a href="/project/natus-engine">NATUS Engine</a></h6>
                            <h6 style={{ float:"right" }}><a href="/project/ruined-city">Ruined City</a></h6>
                        </footer>
                    </section>

                    <footer id="footer">
                        <ul className="copyright">
                            <li>&copy; natus.io</li>
                            <li>Buenos Aires, Argentina</li>
                        </ul>
                    </footer>

                </div>

            </div>
        );
    }
}

export default connect()(Maintenance);


// WEBPACK FOOTER //
// ./src/components/Maintenance.js